(() => {
  const centers = document.querySelectorAll('[data-bbj-support-center]');
  if (!centers.length) return;

  const field = (name, label, type = 'text', options = {}) => ({
    name,
    label,
    type,
    required: Boolean(options.required),
    wide: Boolean(options.wide),
    placeholder: options.placeholder || '',
    choices: options.choices || [],
    value: options.value || ''
  });

  const configs = {
    tracking: {
      title: 'Track My Order',
      copy: 'Enter your tracking number to check the latest shipping status and delivery updates.',
      inquiry: 'Shipping / Tracking Issue',
      submit: 'Contact Support',
      fields: [
        field('Order Number', 'Order Number', 'text', { required: true }),
        field('email', 'Email', 'email', { required: true })
      ]
    },
    product: {
      title: 'Product Questions',
      copy: '',
      inquiry: 'Product Questions',
      submit: 'Send Question',
      fields: [
        field('Name', 'Name', 'text', { required: true }),
        field('email', 'Email', 'email', { required: true }),
        field('Product Name or Product URL', 'Product Name or Product URL', 'text', { wide: true, placeholder: 'Paste product URL or product name' }),
        field('Question', 'Question', 'textarea', { required: true, wide: true }),
        field('Optional Image Upload', 'Optional image upload', 'file', { wide: true })
      ]
    },
    samples: {
      title: 'Request Samples',
      copy: '',
      inquiry: 'Request Samples',
      submit: 'Request Samples',
      fields: [
        field('Name', 'Name', 'text', { required: true }),
        field('email', 'Email', 'email', { required: true }),
        field('Company / Florist Name', 'Company / Florist Name', 'text'),
        field('Country', 'Country', 'text', { required: true }),
        field('Products Interested In', 'Products Interested In', 'textarea', { required: true, wide: true }),
        field('Estimated Order Size or Monthly Purchase', 'Estimated Order Size or Monthly Purchase', 'text'),
        field('Message', 'Message', 'textarea', { wide: true })
      ]
    },
    printing: {
      title: 'Custom Printing',
      copy: '',
      inquiry: 'Custom Printing',
      submit: 'Request a Quote',
      fields: [
        field('Name', 'Name', 'text', { required: true }),
        field('email', 'Email', 'email', { required: true }),
        field('Company', 'Company', 'text'),
        field('Product Type', 'Product Type', 'text', { required: true }),
        field('Estimated Quantity', 'Estimated Quantity', 'text', { required: true }),
        field('Desired Size / Material', 'Desired Size / Material', 'text'),
        field('Deadline', 'Deadline', 'text', { placeholder: 'e.g. MM/DD/YYYY' }),
        field('Message', 'Message', 'textarea', { required: true, wide: true }),
        field('Optional Logo / Reference Image Upload', 'Optional logo / reference image upload', 'file', { wide: true })
      ]
    },
    order: {
      title: 'Order Issues',
      copy: '',
      inquiry: 'Order Issues',
      submit: 'Submit Issue',
      fields: [
        field('Name', 'Name', 'text', { required: true }),
        field('email', 'Email', 'email', { required: true }),
        field('Order Number', 'Order Number', 'text', { required: true }),
        field('Issue Type', 'Issue Type', 'select', {
          required: true,
          choices: ['Missing Item', 'Wrong Item', 'Damaged Item', 'Tracking / Delivery Issue', 'Other']
        }),
        field('Description', 'Description', 'textarea', { required: true, wide: true }),
        field('Optional Image Upload', 'Optional image upload', 'file', { wide: true })
      ]
    }
  };

  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  const createFileControl = (input) => {
    input.accept = input.accept || 'image/*';
    input.classList.add('bbj-support-file__input');

    const control = document.createElement('span');
    control.className = 'bbj-support-file__control';

    const button = document.createElement('span');
    button.className = 'bbj-support-file__button';
    button.textContent = 'Choose file';

    const status = document.createElement('span');
    status.className = 'bbj-support-file__status';
    status.textContent = 'No file chosen';

    control.append(button, status);
    input.addEventListener('change', () => {
      status.textContent = input.files && input.files.length ? input.files[0].name : 'No file chosen';
    });

    return control;
  };

  const createInput = (fieldConfig) => {
    const label = document.createElement('label');
    if (fieldConfig.wide) label.setAttribute('data-wide', '');
    label.textContent = fieldConfig.label + ' ';

    if (fieldConfig.required) {
      const required = document.createElement('span');
      required.setAttribute('aria-hidden', 'true');
      required.textContent = '*';
      label.appendChild(required);
    }

    let input;
    if (fieldConfig.type === 'textarea') {
      input = document.createElement('textarea');
      input.rows = 5;
    } else if (fieldConfig.type === 'select') {
      input = document.createElement('select');
      const blank = document.createElement('option');
      blank.value = '';
      blank.textContent = 'Please select an option';
      input.appendChild(blank);
      fieldConfig.choices.forEach((choice) => {
        const option = document.createElement('option');
        option.value = choice;
        option.textContent = choice;
        input.appendChild(option);
      });
    } else {
      input = document.createElement('input');
      input.type = fieldConfig.type;
      if (fieldConfig.type === 'file') {
        input.accept = 'image/*';
      }
    }

    input.name = fieldConfig.name === 'email' ? 'contact[email]' : `contact[${fieldConfig.name}]`;
    input.required = fieldConfig.required;
    input.placeholder = fieldConfig.placeholder || '';
    if (fieldConfig.value) input.value = fieldConfig.value;

    if (fieldConfig.type === 'file') {
      label.classList.add('bbj-support-file');
      const control = createFileControl(input);
      label.append(input, control);
      return label;
    }

    label.appendChild(input);
    return label;
  };

  centers.forEach((center) => {
    const modal = center.querySelector('[data-support-modal]');
    const dialog = center.querySelector('.bbj-support-modal__dialog');
    const title = center.querySelector('[data-support-modal-title]');
    const copy = center.querySelector('[data-support-modal-copy]');
    const fieldsWrap = center.querySelector('[data-support-fields]');
    const inquiryInput = center.querySelector('[data-support-inquiry-type]');
    const submit = center.querySelector('[data-support-modal-submit]');
    const trackingPanel = center.querySelector('[data-support-tracking]');
    const trackingForm = center.querySelector('[data-support-tracking-form]');
    const trackingInput = center.querySelector('[data-support-tracking-input]');
    const trackingError = center.querySelector('[data-support-tracking-error]');
    const contactPanel = center.querySelector('[data-support-contact-panel]');
    const expandContact = center.querySelector('[data-support-expand-contact]');
    const directTopic = center.querySelector('[data-support-direct-topic]');
    let previousFocus = null;

    center.querySelectorAll('input[type="file"]').forEach((input) => {
      if (input.classList.contains('bbj-support-file__input')) return;
      input.insertAdjacentElement('afterend', createFileControl(input));
    });

    const closeModal = () => {
      modal.hidden = true;
      document.body.classList.remove('bbj-support-modal-open');
      document.removeEventListener('keydown', onKeydown);
      if (previousFocus) previousFocus.focus();
    };

    const trapFocus = (event) => {
      if (event.key !== 'Tab' || modal.hidden) return;
      const focusable = Array.from(dialog.querySelectorAll(focusableSelector));
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    };

    function onKeydown(event) {
      if (event.key === 'Escape') closeModal();
      trapFocus(event);
    }

    const openModal = (type) => {
      const config = configs[type];
      if (!config) return;

      previousFocus = document.activeElement;
      title.textContent = config.title;
      copy.textContent = config.copy || '';
      inquiryInput.value = config.inquiry;
      submit.textContent = config.submit;
      fieldsWrap.replaceChildren(...config.fields.map((item) => createInput(item)));

      const isTracking = type === 'tracking';
      modal.classList.toggle('bbj-support-modal--tracking', isTracking);
      dialog.classList.toggle('bbj-support-modal__dialog--tracking', isTracking);
      trackingPanel.hidden = !isTracking;
      contactPanel.hidden = isTracking;
      if (isTracking) {
        trackingInput.value = '';
        trackingInput.removeAttribute('aria-invalid');
        trackingError.hidden = true;
        expandContact.setAttribute('aria-expanded', 'false');
      }

      const productUrlField = fieldsWrap.querySelector('input[name="contact[Product Name or Product URL]"]');
      if (productUrlField && /\/products\//.test(window.location.pathname)) {
        productUrlField.value = window.location.href;
      } else if (productUrlField && /\/products\//.test(document.referrer)) {
        productUrlField.value = document.referrer;
      }

      modal.hidden = false;
      document.body.classList.add('bbj-support-modal-open');
      document.addEventListener('keydown', onKeydown);
      requestAnimationFrame(() => {
        const first = dialog.querySelector(focusableSelector);
        (first || dialog).focus();
      });
    };

    center.addEventListener('click', (event) => {
      const button = event.target.closest('[data-support-open]');
      if (!button || !center.contains(button)) return;
      openModal(button.dataset.supportOpen);
    });

    center.querySelectorAll('[data-support-close]').forEach((button) => {
      button.addEventListener('click', closeModal);
    });

    trackingForm.addEventListener('submit', (event) => {
      event.preventDefault();
      const trackingNumber = trackingInput.value.trim();
      if (!trackingNumber) {
        trackingInput.setAttribute('aria-invalid', 'true');
        trackingError.hidden = false;
        trackingInput.focus();
        return;
      }

      trackingInput.removeAttribute('aria-invalid');
      trackingError.hidden = true;
      window.open(`https://www.17track.net/en/track?nums=${encodeURIComponent(trackingNumber)}`, '_blank', 'noopener,noreferrer');
    });

    trackingInput.addEventListener('input', () => {
      if (!trackingInput.value.trim()) return;
      trackingInput.removeAttribute('aria-invalid');
      trackingError.hidden = true;
    });

    expandContact.addEventListener('click', () => {
      contactPanel.hidden = false;
      expandContact.setAttribute('aria-expanded', 'true');
      const firstContactField = fieldsWrap.querySelector('input, select, textarea');
      if (firstContactField) firstContactField.focus();
    });

    center.querySelectorAll('[data-support-scroll]').forEach((button) => {
      button.addEventListener('click', () => {
        const target = document.querySelector(button.dataset.supportScroll);
        if (!target) return;
        if (directTopic && button.dataset.supportTopic) directTopic.value = button.dataset.supportTopic;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        const firstInput = target.querySelector('input, select, textarea, button');
        if (firstInput) window.setTimeout(() => firstInput.focus({ preventScroll: true }), 450);
      });
    });

    const clickChatTarget = (target) => {
      if (!target) return false;
      target.dispatchEvent(new MouseEvent('pointerdown', { bubbles: true, cancelable: true, view: window }));
      target.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true, view: window }));
      target.click();
      return true;
    };

    const findShadowChatButton = (host) => {
      if (!host || !host.shadowRoot) return null;
      const selectors = [
        '.chat-app > button',
        'button.chat-toggle',
        'button[aria-label*="chat" i]',
        'button[aria-label*="message" i]',
        'button[aria-label*="help" i]',
        'button'
      ];

      for (const selector of selectors) {
        const target = host.shadowRoot.querySelector(selector);
        if (target) return target;
      }

      return null;
    };

    const findDocumentChatButton = () => {
      const candidates = [
        '#ShopifyChat button',
        '[data-shopify-chat] button',
        '[aria-label*="chat" i]',
        '[aria-label*="message" i]',
        '[aria-label*="help" i]',
        '[class*="shopify-chat" i]',
        '[class*="inbox" i]',
        '[class*="gorgias" i]',
        '[class*="tidio" i]'
      ];

      for (const selector of candidates) {
        const target = document.querySelector(selector);
        if (target) return target;
      }

      return null;
    };

    const findIframeChatButton = () => {
      const frames = document.querySelectorAll('iframe[id*="ShopifyChat" i], iframe[src*="inbox" i], iframe[src*="chat" i]');
      for (const frame of frames) {
        try {
          const target = frame.contentDocument?.querySelector('button, [role="button"], .chat-toggle');
          if (target) return target;
        } catch (error) {
          // Cross-origin chat iframes cannot be inspected; continue to other launch paths.
        }
      }

      return null;
    };

    const openExistingChat = () => {
      const action = center.dataset.liveChatAction;
      if (action && action !== 'auto') {
        const target = document.querySelector(action);
        if (clickChatTarget(target)) return true;
      }

      if (window.ShopifyInbox) {
        if (typeof window.ShopifyInbox.open === 'function') {
          window.ShopifyInbox.open();
          return true;
        }
        if (typeof window.ShopifyInbox.show === 'function') {
          window.ShopifyInbox.show();
          return true;
        }
        if (typeof window.ShopifyInbox.toggle === 'function') {
          window.ShopifyInbox.toggle();
          return true;
        }
      }

      const shopifyChat = document.getElementById('ShopifyChat');
      if (clickChatTarget(findShadowChatButton(shopifyChat))) return true;

      const shadowHosts = Array.from(document.querySelectorAll('*')).filter((element) => {
        const key = `${element.id || ''} ${element.className || ''} ${element.tagName || ''}`.toLowerCase();
        return element.shadowRoot && (key.includes('chat') || key.includes('inbox') || key.includes('gorgias') || key.includes('tidio'));
      });

      for (const host of shadowHosts) {
        if (clickChatTarget(findShadowChatButton(host))) return true;
      }

      if (clickChatTarget(findDocumentChatButton())) return true;
      if (clickChatTarget(findIframeChatButton())) return true;

      return false;
    };

    const openChatWithUrlFlag = () => {
      const url = new URL(window.location.href);
      if (url.searchParams.has('show_chat')) return false;
      url.searchParams.set('show_chat', '1');
      window.location.href = url.toString();
      return true;
    };

    center.querySelectorAll('[data-support-live-chat]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!openExistingChat() && !openChatWithUrlFlag()) {
          const target = document.querySelector(`#SupportDirect-${center.className.match(/section-([A-Za-z0-9_-]+)-padding/)?.[1] || ''}`) || center.querySelector('.bbj-support-direct');
          if (directTopic) directTopic.value = 'General Support';
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    const requestedSupport = new URLSearchParams(window.location.search).get('support');
    if (requestedSupport === 'tracking') {
      openModal('tracking');
    }
  });
})();
